import { FC, ReactNode, DetailedHTMLProps, ButtonHTMLAttributes } from 'react'
import { cn } from '@bem-react/classname'

import { Memo } from '@/hoc/Memo'

import './Button.scss'

export type ButtonType = 'button' | 'submit'
export type ButtonIconPositionType = 'left' | 'right'
export type ButtonColorType =
  | 'blue'
  | 'orange'
  | 'outline-gray'
  | 'dark'
  | 'red'
export type positionTooltipType = 'left' | 'right' | 'top' | 'bottom'

const cnButton = cn('Button')

export interface ButtonShema
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  children: ReactNode
  isDisabled?: boolean
  small?: boolean
  xsmall?: boolean
  large?: boolean
  fluid?: boolean
  medium?: boolean
  big?: boolean
  type?: ButtonType
  color?: ButtonColorType
  isLoading?: boolean
  isIcon?: boolean
  onClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  unСlickable?: boolean
  isTooltip?: boolean
  tooltipText?: string
  defaultPositionTooltip?: positionTooltipType
  defaultWidth?: number
  classNameTooltip?: string
}

export const Button: FC<ButtonShema> = Memo(
  ({
    isDisabled,
    isLoading,
    type = 'button',
    small,
    large,
    medium,
    children,
    color,
    fluid,
    className,
    xsmall,
    big,
    isIcon,
    onClick,
    onMouseEnter,
    onMouseLeave,
    unСlickable,
    id,
  }: ButtonShema) => {
    return (
      <>
        <button
          id={id}
          className={cnButton(
            isIcon ? 'icon' : '',
            {
              square: isIcon,
              xsmall,
              big,
              fluid,
              small,
              large,
              medium,
              orange: color === 'orange',
              gray: color === 'outline-gray',
              dark: color === 'dark',
              red: color === 'red',
              loading: isLoading,
              disabled: unСlickable,
            },
            [className],
          )}
          type={type}
          onClick={() => {
            !unСlickable && onClick && onClick()
          }}
          onMouseEnter={() => {
            onMouseEnter && onMouseEnter()
          }}
          onMouseLeave={() => {
            onMouseLeave && onMouseLeave()
          }}
          disabled={isDisabled || isLoading}
        >
          {isLoading ? (
            <i className='fa-solid fa-spinner fa-2x fa-spin'></i>
          ) : (
            children
          )}
        </button>
      </>
    )
  },
)
